export default function(content, defaults) {
    const activeContent = content ? content : defaults
    const { header, image={}, linkTo } = activeContent 
    const description = activeContent.description.text
    return { header, description, image, linkTo }
} 